import React, { useState, useRef, useEffect, useContext } from "react";
import { AuthContext } from "../../common/Auth";

const TextBox2 = () => {
  const spanRef = useRef(null);
  const { themeSettingsData } = useContext(AuthContext);
  const [textBoxData, setTextBoxData] = useState("")

  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0) {
      const textBoxSettings = themeSettingsData.find(
        (item) => item.settingsName === "textBoxSettings2"
        );
        if (spanRef.current) {
          spanRef.current.innerHTML = (textBoxSettings && textBoxSettings?.values && textBoxSettings?.values[0].text) ? textBoxSettings?.values[0].text : "";
        }
    }
  }, [themeSettingsData, spanRef]);

  useEffect(() => {
    themeSettingsData.map((i) => {
      if (i.settingsName === "textBoxSettings2") {
        setTextBoxData(i.values[0]);
      }
    })
  }, [themeSettingsData])

  let pt = textBoxData.paddingTop ? textBoxData.paddingTop : "pt-50";
  let pb = textBoxData.paddingBottom ? textBoxData.paddingBottom : "pb-50";
  let mb = textBoxData.marginBottom ? textBoxData.marginBottom : "mt-50";
  let mt = textBoxData.marginTop ? textBoxData.marginTop : "mb-50";
  let mr = textBoxData.marginRight ? textBoxData.marginRight : "mr-0";
  let ml = textBoxData.marginLeft ? textBoxData.marginLeft : "ml-0";
  let pl = textBoxData.paddingLeft ? textBoxData.paddingLeft : "pl-0";
  let pr = textBoxData.paddingRight ? textBoxData.paddingRight : "pr-0";

  let bgImage = textBoxData?.bgImage ? textBoxData?.bgImage : "";
  let bgColor = textBoxData?.bgColor ? textBoxData?.bgColor : "";

  return (
    <div className={`antera-text-box-two-container textBox-container section-bgImage ${pt} ${pb} ${mb} ${mt} ${mr} ${ml} ${pl} ${pr}`}
    style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}} >
      <div className="container-fluid">
        <div className="row">
          <div className=" col-lg-12 col-md-10 ml-auto mr-auto">
            <span ref={spanRef} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextBox2;
